import {Card, CardBody, Col, Container, Row} from "reactstrap";


import {RiUser3Fill, RiUser3Line} from "react-icons/ri";
import React from "react";
import SmallLoginForm from "./LoginForm";

export function sessionEnded() {
    return       <>
        
        {/*<main ref="main">*/}
            <div className="position-relative">
                {/* shape Hero */}
                <section className="section section-lg section-shaped pb-250">
                    <div className="shape shape-style-1 shape-default">
                        <span/>
                        <span/>
                        <span/>
                        <span/>
                        <span/>
                        <span/>
                        <span/>
                        <span/>
                        <span/>
                    </div>
                    <Container className="py-lg-md d-flex">
                        <div className="col px-0">
                            <Row>
                                <Col lg="8">
                                    <h1 className="display-3 text-white">
                                        Building your song-flows{" "}
                                        <span>benefits</span>
                                    </h1>
                                    {/*<p className="lead text-white">*/}
                                    {/*  The design system comes with four pre-built pages to*/}
                                    {/*  help you get started faster. You can change the text and*/}
                                    {/*  images and you're good to go.*/}
                                    {/*</p>*/}
                                </Col>
                            </Row>
                        </div>
                    </Container>
                    {/* SVG separator */}
                    <div className="separator separator-bottom separator-skew">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                            />
                        </svg>
                    </div>
                </section>
                {/* 1st Hero Variation */}
            </div>
            <section className="section section-lg pt-lg-0 mt--200">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg="12">
                            <Row className="row-grid">
                                <Col lg="8">
                                    <Card className="card-lift--hover shadow border-0">
                                        <CardBody className="py-5">
                                            <Row>
                                                <Col>
                                                    <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                                        <RiUser3Line color='#5e72e4' size="36"/>You must be signed in
                                                    </h2>
                                                </Col>
                                            </Row>
                                            <p className="description mt-3">
                                                You either haven't signed in yet or your session has ended. Please sign in to continue.
                                            </p>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col lg="4">
                                    <Card className="card-lift--hover shadow border-0">
                                        <CardBody className="py-5">
                                            {/*<div className="icon icon-shape icon-shape-warning rounded-circle mb-4">*/}
                                            {/*  <i className="ni ni-planet" />*/}
                                            {/*</div>*/}
                                            <Row>
                                                <Col>
                                                    <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                                        <RiUser3Fill color='#5e72e4' size="36"/>&nbsp;Sign in
                                                    </h2>
                                                    <p className="description mt-3">
                                                    </p>
                                                </Col>
                                            </Row>
                                            <SmallLoginForm/>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        {/*</main>*/}
        
    </>

}